module.exports = __webpack_public_path__ + "SamsungOne-500C.3bf4c58e64febec5c251.ttf";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/SamsungOne-500C.ttf
// module id = ../../../../../src/assets/layout/fonts/SamsungOne-500C.ttf
// module chunks = styles